import { CustomException } from '@tencent/ppd-base-libs';
/**
 * 下划线转成驼峰
 * @param name 输入值
 * @returns
 */
// eslint-disable-next-line no-useless-escape
export const toHump = (name: string): string => name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());

/**
 * 驼峰转成下划线
 * @param name 输入值
 * @returns
 */
export const toLine = (name: string): string => name.replace(/\B([A-Z])/g, '_$1').toLowerCase();

type FormatKey = {
  /** 需要转成 int 类型的 key 数组 */
  needParseIntKey?: string[];
  /** 自定义格式化工具函数 */
  transformer?: (res: any) => any;
};

/** 目标类型枚举 */
export enum TargetType {
  'hump' = 'hump',
  'line' = 'line'
}

/** 用来format的参数 */
export type FormatOptions = {
  /** 待format目标 */
  target: object;
  targetType: TargetType;
} & FormatKey;

/** 用来format的数组参数 */
export type FormatArrOptions = {
  /** 待format值 */
  target: any[];
  targetType: TargetType;
} & FormatKey;

/**
 * 格式化数组元素
 * @param arr 需要格式化的数组
 * @param needParseIntKey 需要转成 int 类型的 key 数组
 * @param needParseDateKey 需要转成 date 类型的 key 数组
 * @returns
 */
const handleFormatArrVal = (options: FormatArrOptions): any[] => {
  const { target } = options;
  return target.map((ele) => {
    // 如果是数组元素
    if (Array.isArray(ele)) {
      return handleFormatArrVal({ ...options, target: ele });
    }
    // 如果是对象元素
    if (Object.prototype.toString.call(ele) === '[object Object]') {
      return handleFormatObj({ ...options, target: ele });
    }
    return ele;
  });
};

/**
 * 处理接口 返回值：key 改成驼峰/下划线，值根据真实需要转换
 * @param options FormatOptions
 * @returns
 */
export const handleFormatObj = (options: FormatOptions): object => {
  const {
    target,
    targetType,
    needParseIntKey = [],
    transformer,
  } = options;
  const res: object = {};
  for (const [key, value] of Object.entries(target || {})) {
    // 转换 key 为驼峰形式 / 下划线形式
    const formattedKey = targetType === TargetType.hump ? toHump(key) : toLine(key);
    if (needParseIntKey.includes(formattedKey)) {
      // 转换并返回 number 类型的数据
      res[formattedKey] = parseInt(value as string, 10);
    } else {
      if (Array.isArray(value)) {
        // 如果返回值是数组
        res[formattedKey] = handleFormatArrVal({ ...options, target: value, transformer: undefined });
      } else if (Object.prototype.toString.call(value) === '[object Object]') {
        // 如果返回值是对象
        res[formattedKey] = handleFormatObj({ ...options, target: value, transformer: undefined });
      } else {
        res[formattedKey] = value;
      }
    }
  }
  if (transformer) {
    return transformer(res as object);
  }
  return res as object;
};

/** 安全地解析json */
export const tryJsonParse = (jsonStr: string) => {
  let obj = {};
  try {
    obj = JSON.parse(jsonStr);
  } catch (e) {
    new CustomException(e, 'dpLoader-tryJsonParseFailed', '解析组件自定义信息失败');
  }
  return obj;
};

/**
 * 格式化处理投放接口返回的dp_list中的每项信息
 */
export const formatDpItem = (item: {[x: string]: any}) => {
  const targetItem = {
    ...item,
    contentBaseData: tryJsonParse(item.contentBaseData),
    isBi: item.isBi === 1,
  } as any;
  // reportInfo不是必返回字段，添加前需要判断
  if (item.reportInfo) {
    targetItem.reportInfo = tryJsonParse(item.reportInfo);
  }
  return targetItem;
};
